import {initNavigation} from './modules/navigation';
import {initSolutions} from './modules/solutions';

document.addEventListener("DOMContentLoaded", function () {
	initNavigation();
	initSolutions();
	isElementExist(".header", initHeaderOffset);
});

let headerHeight;

// Helper if element exist then call function
function isElementExist(_el, _cb, ...rest) {
	const elem = document.querySelector(_el);

	if (document.body.contains(elem)) {
		try {
			_cb(...rest);
		} catch (e) {
			console.error(e);
		}
	}
}

function debounce(func, wait, immediate) {
	let timeout;

	return function() {
		const context = this;
		const args = arguments;

		const later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		const callNow = immediate && !timeout;

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
}

function initHeaderOffset() {
	const header = document.querySelector(".header");

	const adjustDebounced = debounce(function () {
		if (headerHeight !== header.offsetHeight) {
			adjustHeightOffset();
		}
	}, 250);

	function adjustHeightOffset() {
		headerHeight = header.offsetHeight;
		document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
	}

	adjustHeightOffset();

	window.addEventListener("resize", adjustDebounced);
}
